// @ts-nocheck
/**
 * 3DIDS — Top Ventas Home V2
 *
 * Funcionalidades:
 * - Lazy-load de paneles de periodo (mismo patrón que product-tabs-grid)
 * - Filtros de marca y tipo: show/hide con data attributes
 * - Carousel por panel: scroll-snap + flechas con updateArrows
 * - Populate dropdowns desde datos JSON del metaobject
 *
 * Todos los periodos se renderizan server-side con bloques nativos del tema.
 * Los periodos inactivos viven en <template data-lazy-period> y se extraen al DOM en demanda.
 */
(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.tv3hv2Init) return;
    sectionEl.dataset.tv3hv2Init = '1';

    var sectionId = sectionEl.dataset.sectionId;
    var dataEl    = document.getElementById('tv3hv2-data-' + sectionId);
    var allData   = {};

    try { allData = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) {}

    var timeSelect   = sectionEl.querySelector('[data-filter="time"]');
    var vendorSelect = sectionEl.querySelector('[data-filter="vendor"]');
    var typeSelect   = sectionEl.querySelector('[data-filter="product-type"]');

    var activePeriod      = (timeSelect && timeSelect.value) || sectionEl.dataset.activePeriod || '30d';
    var maxProducts       = parseInt(sectionEl.dataset.maxProducts, 10) || 20;
    var maxProductsMobile = parseInt(sectionEl.dataset.maxProductsMobile, 10) || 6;

    /* Devuelve el límite de productos según el viewport actual */
    function getMaxProducts() {
      return window.innerWidth <= 1023 ? maxProductsMobile : maxProducts;
    }

    /* ─────────────────────────────────────────────
       CAROUSEL — arrows + scroll por panel
       ───────────────────────────────────────────── */
    function updateArrows(panel) {
      var track   = panel.querySelector('[data-tv3hv2-track]');
      var prevBtn = panel.querySelector('[data-tv3hv2-prev]');
      var nextBtn = panel.querySelector('[data-tv3hv2-next]');
      if (!track) return;

      var sl  = Math.round(track.scrollLeft);
      var sw  = Math.round(track.scrollWidth);
      var cw  = Math.round(track.clientWidth);

      if (prevBtn) prevBtn.toggleAttribute('hidden', sl <= 1);
      if (nextBtn) nextBtn.toggleAttribute('hidden', sw - sl - cw <= 1);
    }

    function bindCarousel(panel) {
      var track   = panel.querySelector('[data-tv3hv2-track]');
      var prevBtn = panel.querySelector('[data-tv3hv2-prev]');
      var nextBtn = panel.querySelector('[data-tv3hv2-next]');
      if (!track || panel.dataset.carouselBound) return;
      panel.dataset.carouselBound = '1';

      function scrollByOne(direction) {
        var visibleItem = track.querySelector('.tv3hv2__item:not([hidden])');
        if (!visibleItem) return;
        var gap       = parseFloat(getComputedStyle(track).gap) || 0;
        var itemWidth = visibleItem.offsetWidth + gap;
        track.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOne(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOne(1); });

      track.addEventListener('scroll', function () { updateArrows(panel); }, { passive: true });
      /* scrollend fires after snap animation settles — more accurate than scroll alone */
      track.addEventListener('scrollend', function () { updateArrows(panel); }, { passive: true });

      track.scrollLeft = 0;
      /* Defer first updateArrows so layout is stable */
      requestAnimationFrame(function () { updateArrows(panel); });
    }

    /* ─────────────────────────────────────────────
       FETCH CARDS — Section Rendering API
       /products/{handle}?sections={sectionId}
       Devuelve el HTML nativo del bloque _product-card
       con la misma configuración del periodo activo.
       ───────────────────────────────────────────── */
    var cardCache = {};

    function fetchCardHtml(handle) {
      if (cardCache[handle] !== undefined) {
        return Promise.resolve(cardCache[handle]);
      }
      /* Guardamos la Promise en caché inmediatamente para evitar
         fetches paralelos del mismo handle mientras está en vuelo. */
      var promise = fetch('/products/' + handle + '?sections=' + sectionId)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var raw = (data && data[sectionId]) || null;
          if (!raw) { cardCache[handle] = null; return null; }
          /* Extraemos solo product-card descartando la <section> wrapper,
             <style> y <script> tags que no deben inyectarse repetidamente. */
          var temp = document.createElement('div');
          temp.innerHTML = raw;
          var card = temp.querySelector('product-card-link') || temp.querySelector('product-card');
          var html = card ? card.outerHTML : null;
          cardCache[handle] = html;
          return html;
        })
        .catch(function () { cardCache[handle] = null; return null; });
      cardCache[handle] = promise;
      return promise;
    }

    /* IntersectionObserver — solo carga cards visibles en el carousel.
       Con 550ms por fetch, disparar 20 simultáneos satura Shopify.
       IO garantiza máx ~5-6 fetches en vuelo (columnas visibles),
       y va cargando el resto conforme el usuario hace scroll. */
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var item = entry.target;
        cardObserver.unobserve(item);
        if (!item.classList.contains('tv3hv2__item--fetch')) return;
        fetchCardHtml(item.dataset.handle).then(function (html) {
          if (!html || !item.classList.contains('tv3hv2__item--fetch')) return;

          /* Insert HTML first so web-components initialize, then keep the
             shimmer visible until the first product image is painted.
             This prevents the "image-only shimmer" flash where the card
             text renders but the image slot is blank. */
          item.insertAdjacentHTML('beforeend', html);

          function revealItem() {
            item.classList.remove('tv3hv2__item--fetch');
            /* Capture real card height so future --fetch items use the
               correct min-height instead of the CSS fallback. */
            if (!sectionEl.style.getPropertyValue('--tv3hv2-card-h')) {
              requestAnimationFrame(function () {
                var h = item.offsetHeight;
                if (h > 0) sectionEl.style.setProperty('--tv3hv2-card-h', h + 'px');
              });
            }
          }

          var img = item.querySelector('img[loading="eager"]') || item.querySelector('img');
          if (img && !img.complete) {
            var tid = setTimeout(revealItem, 2000);
            img.addEventListener('load',  function () { clearTimeout(tid); revealItem(); }, { once: true });
            img.addEventListener('error', function () { clearTimeout(tid); revealItem(); }, { once: true });
          } else {
            revealItem();
          }
        });
      });
    }, {
      /* 400px de lookahead horizontal: pre-carga la siguiente card
         antes de que sea visible, para un scroll suave sin esperas. */
      rootMargin: '0px 400px 0px 400px',
      threshold: 0
    });

    function fillFetchItems(panel) {
      var items = panel.querySelectorAll('.tv3hv2__item--fetch:not([hidden])');
      if (!items.length) return;
      Array.from(items).forEach(function (item) {
        cardObserver.observe(item);
      });
    }

    /* ─────────────────────────────────────────────
       FILTROS — populate dropdowns desde JSON
       ───────────────────────────────────────────── */
    function populateDropdowns(period) {
      var ranking = Array.isArray(allData[period]) ? allData[period] : [];

      if (vendorSelect) {
        var prevVendor = vendorSelect.value;
        var vendors   = [];
        var vendorSet = {};
        ranking.forEach(function (p) {
          if (p.vendor && !vendorSet[p.vendor]) {
            vendorSet[p.vendor] = true;
            vendors.push(p.vendor);
          }
        });
        vendors.sort();

        var vendorLabel = (vendorSelect.options[0] && vendorSelect.options[0].text) || '';
        var vFrag = document.createDocumentFragment();
        var vBlank = document.createElement('option');
        vBlank.value = ''; vBlank.textContent = vendorLabel;
        vFrag.appendChild(vBlank);
        vendors.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v;
          o.textContent = v;
          vFrag.appendChild(o);
        });
        vendorSelect.replaceChildren(vFrag);
        if (prevVendor && vendors.indexOf(prevVendor) !== -1) {
          vendorSelect.value = prevVendor;
        }
      }

      if (typeSelect) {
        var prevType = typeSelect.value;
        var types   = [];
        var typeSet = {};
        ranking.forEach(function (p) {
          if (p.productType && !typeSet[p.productType]) {
            typeSet[p.productType] = true;
            types.push(p.productType);
          }
        });
        types.sort();

        var typeLabel = (typeSelect.options[0] && typeSelect.options[0].text) || '';
        var tFrag = document.createDocumentFragment();
        var tBlank = document.createElement('option');
        tBlank.value = ''; tBlank.textContent = typeLabel;
        tFrag.appendChild(tBlank);
        types.forEach(function (t) {
          var o = document.createElement('option');
          o.value = t;
          o.textContent = t;
          tFrag.appendChild(o);
        });
        typeSelect.replaceChildren(tFrag);
        if (prevType && types.indexOf(prevType) !== -1) {
          typeSelect.value = prevType;
        }
      }
    }

    /* ─────────────────────────────────────────────
       FILTROS — show/hide items dentro del panel
       Sin filtro activo : solo items con rank <= maxProducts.
       Con filtro en desktop: muestra todos los matches del ranking.
       Con filtro en mobile : muestra los primeros N matches (top-N del filtro).
       ───────────────────────────────────────────── */
    function filterItems(panel, vendor, type) {
      var hasFilter  = !!(vendor || type);
      var limit      = getMaxProducts();
      var isMobile   = window.innerWidth <= 1023;
      var visibleCount = 0;
      var matchCount   = 0;
      var items = panel.querySelectorAll('.tv3hv2__item');
      items.forEach(function (item) {
        var matchVendor = !vendor || item.dataset.vendor === vendor;
        var matchType   = !type   || item.dataset.productType === type;
        var matches     = matchVendor && matchType;
        var show;
        if (!hasFilter) {
          show = matches && parseInt(item.dataset.rank, 10) <= limit;
        } else if (isMobile) {
          /* Mobile + filtro: los primeros N que coincidan (orden DOM = orden ranking) */
          if (matches) matchCount++;
          show = matches && matchCount <= limit;
        } else {
          show = matches;
        }
        item.toggleAttribute('hidden', !show);
        if (show) {
          visibleCount++;
          var badge = item.querySelector('.tv3hv2__badge');
          if (badge) badge.textContent = (hasFilter ? visibleCount : parseInt(item.dataset.rank, 10)) + 'º';
        }
      });
      var emptyMsg = panel.querySelector('.tv3hv2__empty-filter');
      if (emptyMsg) emptyMsg.toggleAttribute('hidden', visibleCount > 0);
    }

    /* Inyecta en el track skeletons de items del ranking completo que
       coinciden con el filtro pero no están todavía en el DOM.
       En mobile limita los inyectados al tope móvil para evitar nodos innecesarios. */
    function ensureFilteredItemsInDOM(panel, vendor, type) {
      var period  = panel.dataset.period;
      var ranking = Array.isArray(allData[period]) ? allData[period] : [];
      var track   = panel.querySelector('[data-tv3hv2-track]');
      if (!track) return;

      var isMobile = window.innerWidth <= 1023;
      var limit    = isMobile ? getMaxProducts() : Infinity;

      var existing = new Set(
        Array.from(panel.querySelectorAll('.tv3hv2__item')).map(function (el) { return el.dataset.handle; })
      );

      /* Cuenta cuántos items ya en el DOM coinciden con el filtro activo */
      var matchCount = 0;
      panel.querySelectorAll('.tv3hv2__item').forEach(function (el) {
        var mv = !vendor || el.dataset.vendor === vendor;
        var mt = !type   || el.dataset.productType === type;
        if (mv && mt) matchCount++;
      });

      ranking.forEach(function (entry, idx) {
        if (existing.has(entry.handle)) return;
        var matchVendor = !vendor || entry.vendor === vendor;
        var matchType   = !type   || entry.productType === type;
        if (!matchVendor || !matchType) return;

        matchCount++;
        if (matchCount > limit) return;

        var item = document.createElement('div');
        item.className = 'tv3hv2__item tv3hv2__item--fetch';
        item.dataset.handle      = entry.handle;
        item.dataset.vendor      = entry.vendor || '';
        item.dataset.productType = entry.productType || '';
        item.dataset.rank        = idx + 1;
        item.innerHTML = '<span class="tv3hv2__badge" aria-hidden="true">' + (idx + 1) + 'º</span>';
        track.appendChild(item);
      });
    }

    function applyFiltersToPanel(panel) {
      var v = vendorSelect ? vendorSelect.value : '';
      var t = typeSelect   ? typeSelect.value   : '';
      if (v || t) ensureFilteredItemsInDOM(panel, v, t);
      filterItems(panel, v, t);
      var track = panel.querySelector('[data-tv3hv2-track]');
      if (track) track.scrollLeft = 0;
      updateArrows(panel);
      fillFetchItems(panel);
    }

    /* ─────────────────────────────────────────────
       PANEL — activar periodo
       ───────────────────────────────────────────── */
    function activatePanel(period) {
      var panels = sectionEl.querySelectorAll('.tv3hv2__panel');
      var targetPanel = null;

      panels.forEach(function (panel) {
        var isTarget = panel.dataset.period === period;
        panel.classList.toggle('tv3hv2__panel--hidden', !isTarget);
        if (isTarget) targetPanel = panel;
      });

      if (!targetPanel) return;

      var tpl = targetPanel.querySelector('template[data-lazy-period]');
      if (tpl) {
        /* Two-frame defer: first rAF lets the browser paint the empty panel,
           second rAF inserts the heavy web-component content.
           This ensures the dropdown has fully closed and the page has repainted
           before the synchronous connectedCallback() cascade begins. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            targetPanel.appendChild(tpl.content);
            tpl.remove();
            bindCarousel(targetPanel);
            applyFiltersToPanel(targetPanel);
          });
        });
      } else {
        applyFiltersToPanel(targetPanel);
      }
    }

    /* ─────────────────────────────────────────────
       EVENT BINDINGS
       ───────────────────────────────────────────── */
    if (timeSelect) {
      timeSelect.addEventListener('change', function () {
        activePeriod = timeSelect.value;
        /* Defer ALL DOM work so browser can close the native dropdown and repaint
           before we rebuild option lists and toggle panel visibility in one task. */
        setTimeout(function () {
          populateDropdowns(activePeriod);
          activatePanel(activePeriod);
        }, 0);
      });
    }

    if (vendorSelect) {
      vendorSelect.addEventListener('change', function () {
        var panel = sectionEl.querySelector('.tv3hv2__panel[data-period="' + activePeriod + '"]');
        if (panel) applyFiltersToPanel(panel);
      });
    }

    if (typeSelect) {
      typeSelect.addEventListener('change', function () {
        var panel = sectionEl.querySelector('.tv3hv2__panel[data-period="' + activePeriod + '"]');
        if (panel) applyFiltersToPanel(panel);
      });
    }

    /* ─────────────────────────────────────────────
       PRE-WARM — inicializar paneles lazy en idle
       Procesa un panel por cada idle callback para
       no bloquear el main thread. Cuando el usuario
       cambia de periodo ya no hay web-component init.
       ───────────────────────────────────────────── */
    function prewarmPanels() {
      var queue = Array.from(
        sectionEl.querySelectorAll('template[data-lazy-period]')
      );
      if (!queue.length) return;

      function processNext() {
        var tpl = queue.shift();
        if (!tpl) return;
        var panel = tpl.parentNode;
        if (!panel) return processNext();

        panel.appendChild(tpl.content);
        tpl.remove();
        bindCarousel(panel);
        applyFiltersToPanel(panel);

        if (queue.length) {
          if (typeof requestIdleCallback !== 'undefined') {
            requestIdleCallback(processNext, { timeout: 8000 });
          } else {
            setTimeout(processNext, 600);
          }
        }
      }

      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(processNext, { timeout: 5000 });
      } else {
        setTimeout(processNext, 2500);
      }
    }

    /* ─────────────────────────────────────────────
       INIT
       ───────────────────────────────────────────── */
    populateDropdowns(activePeriod);

    var activePanel = sectionEl.querySelector('.tv3hv2__panel[data-period="' + activePeriod + '"]:not(.tv3hv2__panel--hidden)');
    if (activePanel) {
      bindCarousel(activePanel);
      applyFiltersToPanel(activePanel);

      /* Measure height of a server-rendered card so lazy-panel fetch
         items get the correct min-height from the start. */
      requestAnimationFrame(function () {
        var rendered = activePanel.querySelector('.tv3hv2__item:not(.tv3hv2__item--fetch)');
        if (rendered && rendered.offsetHeight > 0) {
          sectionEl.style.setProperty('--tv3hv2-card-h', rendered.offsetHeight + 'px');
        }
      });
    }

    prewarmPanels();
  }

  /* ─────────────────────────────────────────────
     BOOTSTRAP — initial + shopify:section:load
     ───────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.tv3hv2[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor re-init */
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target && e.target.querySelector('.tv3hv2[data-section-id]');
    if (sectionEl) {
      delete sectionEl.dataset.tv3hv2Init;
      initSection(sectionEl);
    }
  });
})();
